import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { EmailContainer } from '../../molecules/EmailContainer'
import { RevalidateCard } from '../../organisms/RevalidateCard'
import { ConfirmPhoneOverrideModal } from '../../templates/ConfirmPhoneOverrideModal/ConfirmPhoneOverrideModal'
import {
  overridePhonePinCodeSMS,
  overrideValidationPhonePinCodeSMS,
} from '../../../api/phoneValidationApiCall'
import { RevalidationContext } from '../../../util/providers/RevalidationProvider'

export const RemoveRevalidationPhoneCheckPinCodePage = ({ onSuccess, onBackClick }) => {
  const { emailsInUse, phone, token, pinCode, lurker } = useContext(RevalidationContext)

  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState({ showGenericError: false })

  const onOverrideClick = e => {
    e.preventDefault()
    setModalOpen(true)
  }

  const closeModal = e => {
    e.preventDefault()
    setModalOpen(false)
  }

  const onPhoneOverrideSuccess = () => {
    lurker.viewMessageEvt('success')
    if (typeof onSuccess === 'function') {
      onSuccess()
    }
  }

  const onGenericError = (error = {}, eventName = 'error') => {
    lurker.viewMessageEvt(eventName, {
      accounts_reason: 'unexpected_error',
      accounts_error_message: (error && error.message) || 'unknown',
    })
    setError({ showGenericError: true })
  }

  const onPhoneOverrideClick = () => {
    setLoading(true)
    const isChangedPhone = !phone.value.includes('*')

    const overridePhonePromise = isChangedPhone
      ? overridePhonePinCodeSMS(
          phone.value,
          'PHONE',
          pinCode,
          'AccountsValhallaRevalidation',
          token
        )
      : overrideValidationPhonePinCodeSMS(pinCode, token)

    overridePhonePromise
      .then(onPhoneOverrideSuccess)
      .catch(err => onGenericError(err, 'error'))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    lurker.pageLoadEvt('revalidate_phone_override')
  }, [])

  return (
    <>
      <RevalidateCard
        title={`Seu telefone ${phone.value} já está vinculado às seguintes contas`}
        alertDescription="Só é permitido um telefone vinculado a uma conta. Ao continuar a verificação, ele será desvinculado dessas contas e os anúncios nelas serão deletados."
        buttonDescription="Continuar verificação e desvínculo"
        onSend={onOverrideClick}
        onBack={onBackClick}
      >
        {emailsInUse.map(email => (
          <EmailContainer key={email} email={email} />
        ))}
      </RevalidateCard>

      <ConfirmPhoneOverrideModal
        loading={loading}
        isOpen={modalOpen}
        emails={emailsInUse}
        onConfirm={onPhoneOverrideClick}
        closeModal={closeModal}
        {...error}
      />
    </>
  )
}

RemoveRevalidationPhoneCheckPinCodePage.propTypes = {
  onSuccess: PropTypes.func,
  onBackClick: PropTypes.func,
}
